import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { ISchemaRequest } from '../../../models/index';
import { getSchemaType } from '../../actions/actionType/events/SchemaActionTypes';
import {
  clearSchemas,
  fetchSchemaFailure,
  fetchSchemaStarted,
  fetchSchemaSuccess
} from '../../actions/sagaActions/events/SchemaNameSagaActions';
import {
  FetchSchemaFailurePayload,
  FetchSchemaRequest
} from '../../actions/types/events/FetchSchemaDetailTypes';

/**
 * Call Gets Schemas by ID API
 * @param schemaName : string
 * @returns api response
 */
export async function callGetSchemaApi(
  schemaName: string
) {
  return apiWrapper.get<ISchemaRequest>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_SCHEMA_BASE_URL}/schemas/${schemaName}/version/latest`,
    headersInstance()
  );
}

/**
 * Saga to get Schema by schemaName
 * @param schemaName:string
 */
export function* getSchemaBySchemaName({ schemaName }: FetchSchemaRequest) {
  yield put(clearSchemas());
  yield put(fetchSchemaStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callGetSchemaApi, schemaName);
    if (isError) {
      throw error;
    }
    if (data) {
      yield put(fetchSchemaSuccess(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error: any) {
    const obj: FetchSchemaFailurePayload = {
      error: String(error),
      errorCode: String(error?.response?.data.error_code),
      schemaErrorMessage: error?.response?.data?.errorMessage
    };
    yield put(fetchSchemaFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchSchemaSaga() {
  yield takeLatest(getSchemaType.FETCH_SCHEMA_REQUEST, getSchemaBySchemaName);
}

export const getSchemaSaga = [fork(fetchSchemaSaga)];
